// extracted by mini-css-extract-plugin
module.exports = {"tagWrapper":"Tag_tagWrapper__1W4mK","tag":"Tag_tag__3-yn8","hint":"Tag_hint__2R9bF"};